// extracted by mini-css-extract-plugin
export var card = "_pc-0";
export var content = "_pc-2";
export var details = "_pc-3";
export var icon = "_pc-1";
export var iconBlue = "_pc-5";
export var iconBrand = "_pc-4";
export var iconGrayBlue = "_pc-6";
export var iconGreen = "_pc-7";
export var iconIndigo = "_pc-8";
export var iconOrange = "_pc-9";
export var iconPurple = "_pc-a";
export var iconRed = "_pc-b";
export var iconWarning = "_pc-c";